/**
 * The last organization this browser used, so the home path can return to it. It holds an identifier only, and
 * storage that refuses or is absent only loses the convenience.
 */
export class Remembered {
	static readonly #key = 'beyond.cdn.organization';

	#storage: Pick<Storage, 'getItem' | 'setItem'> | undefined;

	constructor(storage?: Pick<Storage, 'getItem' | 'setItem'>) {
		this.#storage = storage;
	}

	get organization(): string | undefined {
		try {
			return this.#storage?.getItem(Remembered.#key) ?? undefined;
		} catch {
			return undefined;
		}
	}

	set organization(value: string | undefined) {
		try {
			value && this.#storage?.setItem(Remembered.#key, value);
		} catch {
			// The preference is a convenience
		}
	}
}
